import router from "next/router";
import { useMemo } from "react";

import { RouteConfig } from "@/config/route.config";
import { useScheduledLiveshow } from "@/hooks/useScheduledLiveshow";

const LiveshowGradient = () => {
  const isLossdogLiveshowsPage = useMemo(() => {
    return router.pathname === RouteConfig.Liveshow.slice(0, -1);
  }, []);

  const { hasScheduledLiveshow } = useScheduledLiveshow();

  return (
    isLossdogLiveshowsPage &&
    hasScheduledLiveshow && (
      <div className="liveshow-red-gradient pointer-events-none absolute top-0 right-0 left-0 h-[300px] w-full -translate-y-2/3" />
    )
  );
};

export default LiveshowGradient;
